import { ProductOfferingPricing } from '@travelwin/core';

import { Price } from '@/components/PlanCard/components/Price';

type Props = {
  pricing: ProductOfferingPricing;
};

const className = 'c-PlanCard';

const PlanPrice = ({ pricing }: Props) => {
  const currencyAlias = pricing.currency.alias;
  const price = pricing.total_price_gross;
  const oldPrice = pricing.old_product_price_gross;
  return (
    <div className={`${className}__plan-price`}>
      {oldPrice !== null ? (
        <div className={`${className}__old-price`}>
          <Price currencyAlias={currencyAlias} price={oldPrice} />
        </div>
      ) : null}
      <div className={`${className}__price`} data-testid="div-plan-price">
        <Price currencyAlias={currencyAlias} price={price} />
      </div>
    </div>
  );
};

export default PlanPrice;
